import type { CrudArgs } from "./composables/ContextVoter";
import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class AccessInvitationVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessinvitationCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessinvitationCreate,
    });
  };

  /** Website apps are platform access: an app-access invitation, or website apps added to a role invitation. */
  public canCreateAppAccess = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationAccessinvitationCreateappaccessany,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessinvitationReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessinvitationRead,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessinvitationUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessinvitationUpdate,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessinvitationDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessinvitationDelete,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationAccessinvitationCreateany,
        PermissionAttributesEnum.GlobalOperationAccessinvitationUpdateany,
        PermissionAttributesEnum.GlobalOperationAccessinvitationDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationAccessinvitationCreate,
        PermissionAttributesEnum.ContextOperationAccessinvitationUpdate,
        PermissionAttributesEnum.ContextOperationAccessinvitationDelete,
      ],
    });
  };

  public canAccess(item?: CrudArgs): boolean {
    return this._canCrud({
      item: item ?? {
        client: this.permissionService.defaultClient,
        location: this.permissionService.defaultLocation,
      },
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessinvitationReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessinvitationRead,
    });
  }
}
